import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { AdminSetupService } from "../../services/adminsetup.service";
import { ScheduleTemplateInfo, SetScheduleRequest } from "../../services/SetScheduleRequest";
import * as moment from "moment";

@Component({
	selector: "app-set-calendar",
	templateUrl: "./set-calendar.component.html",
	styleUrls: ["./set-calendar.component.css"],
})
export class SetCalendarComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private adminSetupService: AdminSetupService
	) {}

	ngOnInit(): void {
		this.SchoolID = this.dialogConfig.data.SchoolID;
		// this.lstSchoolDay = this.dialogConfig.data.lstSchoolDay;
		this.lstBellSchedule = this.dialogConfig.data.lstBellSchedule;

		var lstSD: any = [];
		for (var z = 0; z < this.dialogConfig.data.lstSchoolDay.length; z++) {
			var next = this.dialogConfig.data.lstSchoolDay[z];

			var nextEntry = {
				DayID: next.DayID,
				DayDesc: next.DayDesc,
			};

			if (nextEntry.DayID == -1) {
				nextEntry.DayID = -2;
			}

			lstSD = [...lstSD, nextEntry];
		}
		this.lstSchoolDay = lstSD;

		this.lstSchoolDay.unshift({
			DayID: -1,
			DayDesc: "Don't Change",
		});

		this.lstBellSchedule.unshift({
			BellScheduleID: -1,
			BellScheduleDesc: "Don't Change",
		});

		this.loadTemplates();
		this.loadDateOptions();
	}

	//////////////////////////////////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////////////////////////////////

	SchoolID: number = -1;

	//
	// Schedule Options
	//
	ScheduleTypeID: number = 1; // 0 Apply to all days | 1 Pick by day of week | 2 A, B

	Same_DayID: number = -1;
	lstSchoolDay: any = [];

	Same_BellScheduleID: number = -1;
	lstBellSchedule: any = [];

	Same_OpenID: number = -1;
	lstOpen: any = [
		{
			ID: -1,
			Desc: "Don't Change",
		},
		{
			ID: 1,
			Desc: "Open",
		},
		{
			ID: 0,
			Desc: "Closed",
		},
	];

	ClosedWeekends: boolean = true;

	altIndex: number = 0;
	ALPHA: string = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
	StartingDay: any;
	lstAlternating: any = [];

	LSTDOW: string[] = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
	lstDayOfWeek: any = [];

	//
	// Date Options
	//

	DateModeID: number = 0;
	StartMonthYear: any;
	EndMonthYear: any;
	lstMonthYear: any = [];

	SemesterLoading: boolean = false;
	lstSemester: any = [];
	SchoolYearSemesters: any = [];

	OffsetStartDate: Date = null;
	OffsetMinDate: Date = new Date();
	OffsetMaxDate: Date = new Date();
	StartingDayDesc: string = "";

	Processing: boolean = false;

	errorMessage: string = "";

	//////////////////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////////////////////////////////////////////////

	loadTemplates() {
		this.loadDayOfWeeKTemplates();
		this.loadAlternatingTemplates();
	}

	loadDayOfWeeKTemplates() {
		for (var z = 1; z <= 7; z++) {
			var ind = z % this.LSTDOW.length;
			var isWeekend = ind >= 6 || ind <= 0 ? true : false;

			var nextEntry = {
				ID: z,
				Desc: this.LSTDOW[ind],
				DayID: -1,
				BellScheduleID: -1,
				OpenID: isWeekend == true ? 0 : 1,
				IsWeekend: isWeekend,
			};

			this.lstDayOfWeek = [...this.lstDayOfWeek, nextEntry];
		}
	}

	loadAlternatingTemplates() {
		var ADay = {
			ID: this.altIndex,
			Desc: "A Day",
			DayID: -1,
			BellScheduleID: -1,
			OpenID: 1,
		};
		this.altIndex++;
		this.lstAlternating = [...this.lstAlternating, ADay];

		var BDay = {
			ID: this.altIndex,
			Desc: "B Day",
			DayID: -1,
			BellScheduleID: -1,
			OpenID: 1,
		};
		this.altIndex++;
		this.lstAlternating = [...this.lstAlternating, BDay];

		this.StartingDay = this.lstAlternating[0];
	}

	loadDateOptions() {
		this.loadMonthYear();
		this.loadOffset();
		this.loadSemesters();
	}

	loadOffset() {
		//Init to today, ex. 9/6/23 -> Offset Days = 5
		//Added to start date to adjust time
		var Today = new Date();

		this.onOffsetStartDateChange(Today);
		this.OffsetMinDate = new Date(Today.getFullYear(), Today.getMonth(), 1);
		this.OffsetMaxDate = new Date(Today.getFullYear(), Today.getMonth() + 1, 1);
		this.OffsetMaxDate.setDate(this.OffsetMaxDate.getDate() - 1);
	}

	loadMonthYear() {
		var Today = new Date();
		var StartDate = new Date(Today.getFullYear() - 1, 0, 1);
		var EndDate = new Date(Today.getFullYear() + 1, 11, 1);

		var NextDate = StartDate;

		var z = 0;
		while (NextDate <= EndDate) {
			var nextDesc = NextDate.toLocaleString("default", { month: "long" }) + " - " + NextDate.getFullYear();

			var PastMonth = false;
			var CurrentMonth = false;
			var NextColor = "Black";

			if (NextDate.getFullYear() < Today.getFullYear() || (NextDate.getFullYear() == Today.getFullYear() && NextDate.getMonth() < Today.getMonth())) {
				PastMonth = true;
				NextColor = "Orange";
			}

			if (PastMonth == false) {
				CurrentMonth = NextDate.getMonth() == Today.getMonth() && NextDate.getFullYear() == Today.getFullYear() ? true : false;

				if (CurrentMonth == true) {
					NextColor = "Green";
				}
			}

			var nextEntry: any = {
				ID: z,
				Desc: nextDesc,
				NextColor: NextColor,
				DateVal: new Date(NextDate),
			};

			this.lstMonthYear = [...this.lstMonthYear, nextEntry];

			if (CurrentMonth == true) {
				this.StartMonthYear = nextEntry;
				this.EndMonthYear = nextEntry;
			}

			z++;
			NextDate.setMonth(NextDate.getMonth() + 1);
		}
	}

	loadSemesters() {
		this.SemesterLoading = true;

		var result = this.adminSetupService.SemesterSelectList(this.SchoolID);
		result.subscribe(
			(response) => {
				this.SemesterLoading = false;

				this.lstSemester = response;

				var currentYear = new Date().getFullYear();
				for (var z = 0; z < this.lstSemester.length; z++) {
					var next = this.lstSemester[z];

					var nextStartYear = 0;
					if (next.StartDate != undefined) {
						nextStartYear = new Date(next.StartDate).getFullYear();
					}

					var diff = Math.abs(nextStartYear - currentYear);

					if (diff <= 1) {
						this.SchoolYearSemesters = [...this.SchoolYearSemesters, next];
					}
				}
			},
			(error) => {
				this.SemesterLoading = false;
			}
		);
	}

	//////////////////////////////////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////////////////////////////////

	onAddDay() {
		var nextEntry = {
			ID: this.altIndex,
			Desc: this.GetNextLetter() + " Day",
			DayID: -1,
			BellScheduleID: -1,
			OpenID: 1,
		};
		this.altIndex++;
		this.lstAlternating = [...this.lstAlternating, nextEntry];

		if (this.StartingDay == null) {
			this.StartingDay = this.lstAlternating[0];
		}
	}

	onRemoveDay(DayInfo) {
		this.confirmationService.confirm({
			key: "confirmremove",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: "Are you sure you want to remove " + DayInfo.Desc + "s from the schedule?",
			header: "Confirm Remove",
			icon: "fa",
			accept: () => {
				this.onFinishRemoveDay(DayInfo.ID);
			},
		});
	}

	onDeleteAllDays() {
		this.confirmationService.confirm({
			key: "confirmremove",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: "Are you sure you want to remove all days from the schedule?",
			header: "Confirm Remove All",
			icon: "fa",
			accept: () => {
				this.onFinishDeleteAllDays();
			},
		});
	}

	onFinishDeleteAllDays() {
		this.lstAlternating = [];
		this.StartingDay = null;
	}

	onFinishRemoveDay(id) {
		this.lstAlternating = this.lstAlternating.filter((x) => x.ID != id);
		if (this.StartingDay.ID == id) {
			if (this.lstAlternating.length > 0) {
				this.StartingDay = this.lstAlternating[0];
			} else {
				this.StartingDay = null;
			}
		}
	}

	onUpdate() {
		this.errorMessage = "";

		//
		// Error Handling
		//

		//
		// Check Schedule
		//
		if (this.ScheduleTypeID == 1) {
			var anyChanges = false;

			for (var z = 0; z < this.lstDayOfWeek.length; z++) {
				var next = this.lstDayOfWeek[z];

				if (next.DayID != -1 || next.BellScheduleID != -1 || next.OpenID != -1) {
					anyChanges = true;
					break;
				}
			}

			if (anyChanges == false) {
				this.errorMessage = "Select changes to make. All days are set to have no changes";
				return;
			}
		} else if (this.ScheduleTypeID == 2) {
			if (this.lstAlternating.length == 0) {
				this.errorMessage = "Add days to create an A day, B day schedule";
				return;
			}

			var anyChanges = false;
			for (var z = 0; z < this.lstAlternating.length; z++) {
				var next = this.lstAlternating[z];

				if (next.DayID != -1 || next.BellScheduleID != -1 || next.OpenID != -1) {
					anyChanges = true;
					break;
				}
			}

			if (anyChanges == false) {
				this.errorMessage = "Select changes to make. All days are set to have no changes";
				return;
			}
		}
		// else if (this.ScheduleTypeID == 0) {
		// 	if (this.Same_DayID == -1 && this.Same_BellScheduleID == -1 && this.Same_OpenID == -1) {
		// 		this.errorMessage = "Select Changes to make";
		// 		return;
		// 	}
		// }

		//
		// Check Date Range
		//
		if (this.DateModeID == 0) {
			console.log(this.StartMonthYear);
			console.log(this.EndMonthYear);

			if (this.StartMonthYear.DateVal > this.EndMonthYear.DateVal) {
				this.errorMessage = "Start date must be before end date";
				return;
			}
		} else if (this.DateModeID == 1) {
			if (this.SchoolYearSemesters.length == 0) {
				this.errorMessage = "Select semesters to update";
				return;
			}
		}

		//
		// Create WS Request
		//
		var SkipWeekends: number = 1;

		if (this.ScheduleTypeID != 1) {
			SkipWeekends = this.ClosedWeekends == true ? 1 : 0;
		}

		var fsDate: string = "";
		var feDate: string = "";

		if (this.DateModeID == 0) {
			fsDate = moment(this.StartMonthYear.DateVal).format("MM/DD/YYYY");
			feDate = moment(this.EndMonthYear.DateVal).format("MM/DD/YYYY");
		}

		var lstSchedule: ScheduleTemplateInfo[] = [];
		if (this.ScheduleTypeID == 1) {
			for (var z = 0; z < this.lstDayOfWeek.length; z++) {
				var next = this.lstDayOfWeek[z];

				var nextEntry: ScheduleTemplateInfo = {
					DayID: next.DayID,
					BellScheduleID: next.BellScheduleID,
					OpenID: next.OpenID,
				};

				lstSchedule = [...lstSchedule, nextEntry];
			}
		} else if (this.ScheduleTypeID == 2) {
			// Reshuffle list based on starting day
			// (Ex. Want to start the month on a B day. List goes from A, B, C to B, C, A)
			if (this.StartingDay != undefined && this.StartingDay.ID != this.lstAlternating[0].ID) {
				var StartInd = 0;

				for (var z = 0; z < this.lstAlternating.length; z++) {
					var next = this.lstAlternating[z];
					if (next.ID == this.StartingDay.ID) {
						StartInd = z;
						break;
					}
				}
				var lstTemp = [...this.lstAlternating.slice(StartInd), ...this.lstAlternating.slice(0, StartInd)];

				this.lstAlternating = lstTemp;
			}

			for (var z = 0; z < this.lstAlternating.length; z++) {
				var next = this.lstAlternating[z];

				var nextEntry: ScheduleTemplateInfo = {
					DayID: next.DayID,
					BellScheduleID: next.BellScheduleID,
					OpenID: next.OpenID,
				};

				lstSchedule = [...lstSchedule, nextEntry];
			}
		} else if (this.ScheduleTypeID == 0) {
			var nextEntry: ScheduleTemplateInfo = {
				DayID: this.Same_DayID,
				BellScheduleID: this.Same_BellScheduleID,
				OpenID: this.Same_OpenID,
			};

			lstSchedule = [...lstSchedule, nextEntry];
		}

		var lstSemester: number[] = [];

		var OffsetDays = 0;

		// Semester Mode
		if (this.DateModeID == 1) {
			for (var z = 0; z < this.SchoolYearSemesters.length; z++) {
				var next = this.SchoolYearSemesters[z];

				lstSemester = [...lstSemester, next.SemesterID];
			}
		}
		// Month Mode
		else {
			lstSemester = [...lstSemester, -1];

			//Calculate Offset Days
			if (this.OffsetStartDate != undefined) {
				OffsetDays = this.OffsetStartDate.getDate() - 1;
			}
		}

		var parms: SetScheduleRequest = {
			SchoolID: this.SchoolID,
			ScheduleTypeID: this.ScheduleTypeID,
			lstSchedule: lstSchedule,
			SkipWeekends: SkipWeekends,
			DateType: this.DateModeID,
			OffsetDays: OffsetDays,
			StartDate: fsDate,
			EndDate: feDate,
			lstSemesterIDs: lstSemester,
		};

		this.Processing = true;

		var result = this.adminSetupService.SetSchedule(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Status == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "setschedule",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Calendar Settings were updated successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "setschedule",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update calendar settings: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	//////////////////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////////////////
	// Events
	//////////////////////////////////////////////////////////////////////////////////////

	onOffsetStartDateChange(val) {
		this.OffsetStartDate = val;

		this.updateStartingDayDesc();
	}

	onClosedOnWeekendChange(val) {
		this.ClosedWeekends = val;

		this.updateStartingDayDesc();
	}

	updateStartingDayDesc() {
		this.StartingDayDesc = "";
		var DayType = "";
		var fsDate = "";

		if (this.OffsetStartDate == undefined) {
			return;
		}

		if (this.StartingDay != undefined && this.StartingDay.Desc != undefined) {
			DayType = this.StartingDay.Desc;
		} else {
			return;
		}

		//Don't try to find first week day?
		if (this.ClosedWeekends == false) {
			fsDate = this.GetDOW(this.OffsetStartDate.getDay()) + " " + moment(this.OffsetStartDate).format("MM/DD");
		}
		//Find first week day after the start day
		else {
			//Mon 0, Sat 5, Sun 6
			if (this.OffsetStartDate.getDay() > 0 && this.OffsetStartDate.getDay() < 6) {
				fsDate = this.GetDOW(this.OffsetStartDate.getDay()) + " " + moment(this.OffsetStartDate).format("MM/DD");
			} else {
				var currentDate = new Date(this.OffsetStartDate);
				while (currentDate < this.OffsetMaxDate && (currentDate.getDay() < 1 || currentDate.getDay() > 5)) {
					currentDate.setDate(currentDate.getDate() + 1);
				}

				fsDate = this.GetDOW(currentDate.getDay()) + " " + moment(currentDate).format("MM/DD");
			}
		}

		this.StartingDayDesc = "(" + fsDate + " will be a " + DayType + ")";
	}

	onStartMonthYearChange(val) {
		this.StartMonthYear = val;

		this.updateOffset();
	}

	onStartingDayChange(val) {
		this.StartingDay = val;

		this.updateStartingDayDesc();
	}

	updateOffset() {
		//Month Mode
		if (this.DateModeID == 0) {
			//User Start Month/Year's Date
			var DateVal = new Date(this.StartMonthYear.DateVal);
			this.updateOffsetByDateVal(DateVal);
		}
	}

	updateOffsetByDateVal(DateVal: Date) {
		this.onOffsetStartDateChange(DateVal);

		this.OffsetMinDate = new Date(DateVal.getFullYear(), DateVal.getMonth(), 1);
		this.OffsetMaxDate = new Date(DateVal.getFullYear(), DateVal.getMonth() + 1, 1);
		this.OffsetMaxDate.setDate(this.OffsetMaxDate.getDate() - 1);
	}

	//////////////////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.SemesterLoading == true || this.Processing == true;
	}

	GetNextLetter(): string {
		var ind = this.lstAlternating.length % this.ALPHA.length; //Repeats after ~26, but will probably never get that far
		return this.ALPHA[ind];
	}

	GetDOW(day: number): string {
		var ans = "";

		if (day == 0) {
			ans = "Sun";
		} else if (day == 1) {
			ans = "Mon";
		} else if (day == 2) {
			ans = "Tue";
		} else if (day == 3) {
			ans = "Wed";
		} else if (day == 4) {
			ans = "Thu";
		} else if (day == 5) {
			ans = "Fri";
		} else if (day == 6) {
			ans = "Sat";
		}

		return ans;
	}

	//////////////////////////////////////////////////////////////////////////////////////
}
